/// <amd-module name="Likes/LikesConstants" />
export namespace LikesConstants {
    // number of top liked users info to be fetched
    export const TopLikedUsersFetchCount = 10;
}
